import { createMiddlewareAction } from "./createMiddlewareAction"
import { endpoints } from "../api/endpoints"
import { timeSlotsTypes } from "../constantes/actionTypes"

export const timeSlotsActions = {
    getAllTimeSlots: () => (
        createMiddlewareAction({
            successType: timeSlotsTypes.GET_ALL_TIMESLOTS_SUCCESS,
            failureType: timeSlotsTypes.GET_ALL_TIMESLOTS_FAILURE,
            method: "GET",
            endpoint: endpoints.ALL_TIMESLOTS
        })
    ),
}